import { Button } from "@/components/ui";
import ImageGrid from "./ImageGrid";
import { SectionCard, SectionCardTitle } from "@/components";
import { Link } from "react-router-dom";

const WhyChoose = () => {
  return (
    <SectionCard className="grid grid-cols-1 lg:grid-cols-2 lg:gap-30">
      <div className="lg:mt-[60px]">
        <SectionCardTitle>
          Why You Should <br /> Choose Intron
        </SectionCardTitle>
        <br />
        <div className="mt-10">
          <span className="text-[12px] lg:text-[16px] lg:leading-[22px] text-[14px] leading-[28px] text-[#415667] text-justify">
            With over 27 years of experience, expertise, and passion, we drive
            continuous innovation, product development, and improvement - always
            embracing new technologies to stay relevant and focused on exceeding
            customer expectations.
          </span>
          <div className="mt-10 mb-6">
            <Link to={"/about-us/overview"}>
              <Button className="rounded-full">Know More</Button>
            </Link>
          </div>
        </div>
      </div>
      <img
        src="/img/why-choose-us.png"
        className="mt-[10px] lg:mt-5 lg:!h-[450px] lg:!w-[800px] float-animation"
      />
    </SectionCard>
  );
};

export default WhyChoose;
